import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex min-h-[60vh] w-full max-w-portal flex-col items-center justify-center px-4 py-16 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-3xl text-primary-600">
          <i className="ri-film-line" />
        </span>
        <p className="mt-6 font-heading text-5xl font-bold text-background-300">404</p>
        <h1 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这一页好像走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 不存在，
          可能是链接输入有误，或者页面已经调整。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            回到首页
          </Link>
          <Link
            to="/category?type=movie"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}